import { formatDateOnly } from './format-date-only'
import { formatTimeOnly } from './format-time-only'

export const formatDateTime = (timestamp: number): string => {
  const date = formatDateOnly(timestamp)
  const time = formatTimeOnly(timestamp).toUpperCase()
  return `${date} ${time}`
}
